import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect, useState } from 'react';
import classnames from 'classnames';
import { ShippingCosts } from 'server/detail-requests/ShippingCost';
import { LiraAdvContainer } from '@sbt-web/adv';
import { CardBlock } from '@sbt-web/ancillary-services';
import { getPublicUser } from '@sbt-web/auth';
import { SpecialCampaignBanner } from '@sbt-web/banners';
import '@sbt-web/banners/style';
import { useViewport } from '@sbt-web/hooks';
import { CategoryID, FeatureURI, InfoPromo } from '@sbt-web/network/types';
import { Divider } from '@sbt-web/ui';
import { isBrowser, isShippable } from '@sbt-web/utils';
import { AdsAdDetailsBlock } from '@/client/components/Adv/AdSense/adDetails/AdDetailsBlock';
import { AdsGAMPlacement } from '@/client/components/Adv/GPT';
import { LiraContainerIds } from '@/client/components/Adv/Lira/liraContainerIds';
import { LiraLazySlotBelowGalleryForDesktop } from '@/client/components/Adv/Lira/LiraLazySlotBelowGalleryForDesktop';
import { useLiraLazyOverlayGallery } from '@/client/components/Adv/Lira/useLiraLazyOverlayGallery';
import { RecommendedAds } from '@/client/components/Detail/RecommendedAds';
import flattenFeatures from '@/shared/helpers/FlattenFeatures';
import type { HoustonBannerContent } from '@/shared/helpers/getHoustonBannerContent';
import { prepareRemoteDataAdDetail } from '@/shared/helpers/Hebe';
import { isPro } from '@/shared/models/Advertiser';
import { getTransactionFlows } from '@/shared/tools/transaction/utils';
import { getOrCreatePulse } from '@/tools/tracking/utils';
import { useAdvToggle } from '@/client/hooks/useAdvToggle';
import { useAncillaryServicesStatus } from '@/client/hooks/useAncillaryServicesStatus';
import InternalLinksFooter from '../../SEO/InternalLinks/Footer';
import InternalLinksHeader from '../../SEO/InternalLinks/Header';
import NavigationRow from '../NavigationRow';
import StickyBar from '../StickyBar';
import { PaymentMethods } from '../TuttoSubitoInfo/PaymentMethods';
import { ShippingMethods } from '../TuttoSubitoInfo/ShippingMethods';
import type { Props as CommonProps } from './common-props';
import { AdvertiserInfoSection, BottomSection, DescriptionSection, FeatureListSection, GallerySection, GeneralInfoSection, MapSection, RelatedAds, SafetySection, SkyscraperSection } from './Layout';
import { getSpecialCampaignBannerData } from './utils/getSpecialCampaignData';
import css from './style/container.module.scss';
import gridStyles from './style/grid.module.scss';
const dividerClasses = [gridStyles['detail-component'], gridStyles['section-divider']];
const defaultDesktopRightBlockRowSpan = 6;
export type Props = CommonProps & {
  promo: InfoPromo | null;
  shippingCosts: ShippingCosts | null;
  houstonBanner?: HoustonBannerContent | null;
};
const areSafetyTipsActive = (categoryId: CategoryID) => categoryId == CategoryID.ConsoleVideogiochi || categoryId == CategoryID.Informatica || categoryId == CategoryID.AudioVideo || categoryId == CategoryID.Fotografia || categoryId == CategoryID.Telefonia || categoryId == CategoryID.Elettronica || categoryId == CategoryID.CasaPersona || categoryId == CategoryID.ArredamentoCasalinghi || categoryId == CategoryID.GiardinoFaiDaTe || categoryId == CategoryID.AbbigliamentoAccessori || categoryId == CategoryID.TuttoBambini || categoryId == CategoryID.SportsHobby || categoryId == CategoryID.MusicaFilm || categoryId == CategoryID.LibriRiviste || categoryId == CategoryID.StrumentiMusicali || categoryId == CategoryID.Sports || categoryId == CategoryID.Biciclette || categoryId == CategoryID.Collezionismo || categoryId == CategoryID.Animali;
export function DefaultContainer(t0) {
  const $ = _c(163);
  const {
    ad,
    internalLinks,
    shop,
    shopGoogleReviews,
    favoriteCounter,
    advertiserProfile,
    trustInfo,
    promo,
    shippingCosts,
    houstonBanner,
    privateUserInfo,
    userAds
  } = t0;
  const {
    isMobile,
    isDesktop
  } = useViewport();
  let t1;
  if ($[0] !== ad.features || $[1] !== ad.geo) {
    t1 = flattenFeatures(ad.features, ad.geo);
    $[0] = ad.features;
    $[1] = ad.geo;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const features = t1;
  const mapDetails = ad.geo.map;
  const hasMap = mapDetails?.longitude != null && mapDetails?.latitude != null;
  const isSoldItem = ad.features[FeatureURI.TransactionStatus] != undefined;
  const noAdvAdvertiser = ad.advertiser.proPremiumDetailEnabled;
  const [userId, setUserId] = useState(null);
  let t2;
  if ($[3] !== ad || $[4] !== userId) {
    t2 = getTransactionFlows(ad, userId);
    $[3] = ad;
    $[4] = userId;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const transactionFlows = t2;
  const {
    noAdvToggle,
    optimizelyReady
  } = useAdvToggle();
  const ancillaryServicesEnabled = useAncillaryServicesStatus(ad);
  const thereIsNoPlaceForContactButtonElsewhere = transactionFlows.length === 2;
  const userIsSeller = userId === ad.advertiser.userId;
  let t3;
  if ($[6] !== ad || $[7] !== isSoldItem || $[8] !== shippingCosts) {
    t3 = isShippable(ad) && !isSoldItem && shippingCosts !== null;
    $[6] = ad;
    $[7] = isSoldItem;
    $[8] = shippingCosts;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const isTransactionsSectionEnabled = t3;
  let t4;
  let t5;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      if (isBrowser()) {
        setUserId(getPublicUser()?.id);
      }
    };
    t5 = [];
    $[10] = t4;
    $[11] = t5;
  } else {
    t4 = $[10];
    t5 = $[11];
  }
  useEffect(t4, t5);
  let t6;
  if ($[12] !== ad || $[13] !== isMobile) {
    t6 = {
      ad,
      isMobile
    };
    $[12] = ad;
    $[13] = isMobile;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  useLiraLazyOverlayGallery(t6);
  let t7;
  if ($[15] !== ad.category.id) {
    t7 = areSafetyTipsActive(ad.category.id);
    $[15] = ad.category.id;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  const hasSafetyTips = t7;
  let t8;
  if ($[17] !== features.length || $[18] !== hasMap || $[19] !== hasSafetyTips || $[20] !== isSoldItem || $[21] !== isTransactionsSectionEnabled || $[22] !== userIsSeller) {
    t8 = () => {
      let result = defaultDesktopRightBlockRowSpan;
      if (features.length > 0) {
        result = defaultDesktopRightBlockRowSpan + 2;
      }
      if (hasMap) {
        result = result + 1;
      }
      if (isSoldItem && userIsSeller) {
        result = result - 1;
      }
      if (isTransactionsSectionEnabled) {
        result = result + 4;
      }
      if (hasSafetyTips) {
        result = result + 1;
      }
      return result;
    };
    $[17] = features.length;
    $[18] = hasMap;
    $[19] = hasSafetyTips;
    $[20] = isSoldItem;
    $[21] = isTransactionsSectionEnabled;
    $[22] = userIsSeller;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  const [desktopRightBlockRowSpan, setDesktopRightBlockRowSpan] = useState(t8);
  let t9;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = () => setDesktopRightBlockRowSpan(_temp);
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  const increaseRowSpan = t9;
  let t10;
  if ($[25] !== ad || $[26] !== houstonBanner || $[27] !== isSoldItem || $[28] !== promo) {
    t10 = getSpecialCampaignBannerData(ad, isSoldItem, promo, houstonBanner);
    $[25] = ad;
    $[26] = houstonBanner;
    $[27] = isSoldItem;
    $[28] = promo;
    $[29] = t10;
  } else {
    t10 = $[29];
  }
  const specialCampaignBannerData = t10;
  let t11;
  if ($[30] !== internalLinks) {
    t11 = internalLinks !== null ? <div className={classnames(gridStyles["detail-component"], gridStyles["navigation-detail-container"])}><InternalLinksHeader links={internalLinks.header} /></div> : null;
    $[30] = internalLinks;
    $[31] = t11;
  } else {
    t11 = $[31];
  }
  let t12;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = classnames(css["inner-ad-container"], gridStyles["detail-container"]);
    $[32] = t12;
  } else {
    t12 = $[32];
  }
  let t13;
  if ($[33] !== desktopRightBlockRowSpan) {
    t13 = {
      "--right-block-row-span": desktopRightBlockRowSpan
    };
    $[33] = desktopRightBlockRowSpan;
    $[34] = t13;
  } else {
    t13 = $[34];
  }
  let t14;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = classnames([gridStyles["detail-component"], gridStyles["navigation-detail-container"]]);
    $[35] = t14;
  } else {
    t14 = $[35];
  }
  let t15;
  if ($[36] !== ad) {
    t15 = <section className={t14}><NavigationRow item={ad} /></section>;
    $[36] = ad;
    $[37] = t15;
  } else {
    t15 = $[37];
  }
  let t16;
  if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = [gridStyles["detail-component"], gridStyles.gallery];
    $[38] = t16;
  } else {
    t16 = $[38];
  }
  let t17;
  if ($[39] !== ad) {
    t17 = <GallerySection classes={t16} ad={ad} />;
    $[39] = ad;
    $[40] = t17;
  } else {
    t17 = $[40];
  }
  let t18;
  if ($[41] !== isMobile || $[42] !== noAdvAdvertiser || $[43] !== noAdvToggle) {
    t18 = isMobile && noAdvToggle !== "B" && !noAdvAdvertiser && <AdsGAMPlacement classes={[gridStyles["detail-component"]]} id={LiraContainerIds.adView.anchorGallery} fixedHeight={50} />;
    $[41] = isMobile;
    $[42] = noAdvAdvertiser;
    $[43] = noAdvToggle;
    $[44] = t18;
  } else {
    t18 = $[44];
  }
  let t19;
  if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = classnames(gridStyles["detail-component"], gridStyles["right-container"]);
    $[45] = t19;
  } else {
    t19 = $[45];
  }
  let t20;
  if ($[46] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = [gridStyles["ad-info-container"], gridStyles["ad-info-override"]];
    $[46] = t20;
  } else {
    t20 = $[46];
  }
  let t21;
  if ($[47] !== ad || $[48] !== advertiserProfile || $[49] !== favoriteCounter || $[50] !== privateUserInfo || $[51] !== shippingCosts || $[52] !== shop || $[53] !== shopGoogleReviews || $[54] !== specialCampaignBannerData || $[55] !== thereIsNoPlaceForContactButtonElsewhere || $[56] !== trustInfo || $[57] !== userAds) {
    t21 = <GeneralInfoSection classes={t20} ad={ad} shop={shop} shopGoogleReviews={shopGoogleReviews} favoriteCounter={favoriteCounter} advertiserProfile={advertiserProfile} shippingCosts={shippingCosts} trustInfo={trustInfo} specialCampaignBannerData={specialCampaignBannerData} showContactButton={thereIsNoPlaceForContactButtonElsewhere} privateUserInfo={privateUserInfo} userAds={userAds} />;
    $[47] = ad;
    $[48] = advertiserProfile;
    $[49] = favoriteCounter;
    $[50] = privateUserInfo;
    $[51] = shippingCosts;
    $[52] = shop;
    $[53] = shopGoogleReviews;
    $[54] = specialCampaignBannerData;
    $[55] = thereIsNoPlaceForContactButtonElsewhere;
    $[56] = trustInfo;
    $[57] = userAds;
    $[58] = t21;
  } else {
    t21 = $[58];
  }
  let t22;
  if ($[59] !== ad || $[60] !== isDesktop) {
    t22 = isDesktop && <SkyscraperSection item={ad} classes={[gridStyles.skyscraper]} />;
    $[59] = ad;
    $[60] = isDesktop;
    $[61] = t22;
  } else {
    t22 = $[61];
  }
  let t23;
  if ($[62] !== t21 || $[63] !== t22) {
    t23 = <div className={t19}>{t21}{t22}</div>;
    $[62] = t21;
    $[63] = t22;
    $[64] = t23;
  } else {
    t23 = $[64];
  }
  let t24;
  if ($[65] !== isDesktop || $[66] !== specialCampaignBannerData) {
    t24 = isDesktop && specialCampaignBannerData && <div className={gridStyles["detail-component"]}><SpecialCampaignBanner {...specialCampaignBannerData} /></div>;
    $[65] = isDesktop;
    $[66] = specialCampaignBannerData;
    $[67] = t24;
  } else {
    t24 = $[67];
  }
  let t25;
  if ($[68] !== noAdvAdvertiser || $[69] !== noAdvToggle) {
    t25 = noAdvToggle !== "B" && !noAdvAdvertiser && <LiraLazySlotBelowGalleryForDesktop cssClass={gridStyles["detail-component"]} />;
    $[68] = noAdvAdvertiser;
    $[69] = noAdvToggle;
    $[70] = t25;
  } else {
    t25 = $[70];
  }
  let t26;
  if ($[71] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = [gridStyles["detail-component"], gridStyles.description];
    $[71] = t26;
  } else {
    t26 = $[71];
  }
  let t27;
  if ($[72] !== ad) {
    t27 = <DescriptionSection ad={ad} classes={t26} />;
    $[72] = ad;
    $[73] = t27;
  } else {
    t27 = $[73];
  }
  let t28;
  if ($[74] === Symbol.for("react.memo_cache_sentinel")) {
    t28 = <Divider spacing="null" classes={dividerClasses} />;
    $[74] = t28;
  } else {
    t28 = $[74];
  }
  let t29;
  if ($[75] !== isDesktop || $[76] !== noAdvAdvertiser || $[77] !== noAdvToggle) {
    t29 = !isDesktop && noAdvToggle !== "B" && !noAdvAdvertiser && <LiraAdvContainer style={{
      minHeight: "250px"
    }} className={gridStyles["detail-component"]} idForAd={LiraContainerIds.adView.boxBelow1} inlineStyleForAd={{
      display: "block"
    }} />;
    $[75] = isDesktop;
    $[76] = noAdvAdvertiser;
    $[77] = noAdvToggle;
    $[78] = t29;
  } else {
    t29 = $[78];
  }
  let t30;
  if ($[79] !== features) {
    t30 = features.length > 0 && <FeatureListSection features={features} classes={[gridStyles["detail-component"]]} />;
    $[79] = features;
    $[80] = t30;
  } else {
    t30 = $[80];
  }
  let t31;
  if ($[81] !== hasMap || $[82] !== mapDetails) {
    t31 = hasMap && <MapSection classes={[gridStyles["detail-component"], gridStyles.map]} map={mapDetails} />;
    $[81] = hasMap;
    $[82] = mapDetails;
    $[83] = t31;
  } else {
    t31 = $[83];
  }
  let t32;
  if ($[84] !== ad.advertiser.type || $[85] !== isTransactionsSectionEnabled || $[86] !== shippingCosts) {
    t32 = isTransactionsSectionEnabled && <><Divider spacing="null" classes={dividerClasses} /><section className={classnames(gridStyles["detail-component"])}><ShippingMethods costs={shippingCosts} /></section><Divider spacing="null" classes={dividerClasses} /><section className={gridStyles["detail-component"]}><PaymentMethods isPro={isPro(ad.advertiser.type)} /></section></>;
    $[84] = ad.advertiser.type;
    $[85] = isTransactionsSectionEnabled;
    $[86] = shippingCosts;
    $[87] = t32;
  } else {
    t32 = $[87];
  }
  let t33;
  if ($[88] === Symbol.for("react.memo_cache_sentinel")) {
    t33 = classnames(gridStyles["detail-component"], "card-block");
    $[88] = t33;
  } else {
    t33 = $[88];
  }
  let t34;
  if ($[89] !== ad || $[90] !== ancillaryServicesEnabled || $[91] !== isMobile || $[92] !== noAdvToggle || $[93] !== optimizelyReady) {
    t34 = optimizelyReady && noAdvToggle !== "B" && ancillaryServicesEnabled && <CardBlock padding={true} background={true} pulseInstance={getOrCreatePulse()} bannerButtonDesign="outline" item={ad} remoteData={prepareRemoteDataAdDetail("BELOW_FEATURES", ad, isMobile)} />;
    $[89] = ad;
    $[90] = ancillaryServicesEnabled;
    $[91] = isMobile;
    $[92] = noAdvToggle;
    $[93] = optimizelyReady;
    $[94] = t34;
  } else {
    t34 = $[94];
  }
  let t35;
  if ($[95] !== t34) {
    t35 = <div className={t33}>{t34}</div>;
    $[95] = t34;
    $[96] = t35;
  } else {
    t35 = $[96];
  }
  let t36;
  if ($[97] === Symbol.for("react.memo_cache_sentinel")) {
    t36 = <Divider spacing="null" classes={dividerClasses} />;
    $[97] = t36;
  } else {
    t36 = $[97];
  }
  let t37;
  if ($[98] !== isDesktop || $[99] !== noAdvAdvertiser || $[100] !== noAdvToggle) {
    t37 = !isDesktop && noAdvToggle !== "B" && !noAdvAdvertiser && <LiraAdvContainer style={{
      height: "250px"
    }} className={gridStyles["detail-component"]} idForAd={LiraContainerIds.adView.boxBelow3} />;
    $[98] = isDesktop;
    $[99] = noAdvAdvertiser;
    $[100] = noAdvToggle;
    $[101] = t37;
  } else {
    t37 = $[101];
  }
  let t38;
  if ($[102] === Symbol.for("react.memo_cache_sentinel")) {
    t38 = [gridStyles["detail-component"]];
    $[102] = t38;
  } else {
    t38 = $[102];
  }
  let t39;
  if ($[103] !== ad || $[104] !== advertiserProfile || $[105] !== privateUserInfo || $[106] !== shop || $[107] !== shopGoogleReviews || $[108] !== trustInfo || $[109] !== userAds) {
    t39 = <AdvertiserInfoSection classes={t38} item={ad} shop={shop} shopGoogleReviews={shopGoogleReviews} advertiserProfile={advertiserProfile} trustInfo={trustInfo} privateUserInfo={privateUserInfo} userAds={userAds} />;
    $[103] = ad;
    $[104] = advertiserProfile;
    $[105] = privateUserInfo;
    $[106] = shop;
    $[107] = shopGoogleReviews;
    $[108] = trustInfo;
    $[109] = userAds;
    $[110] = t39;
  } else {
    t39 = $[110];
  }
  let t40;
  if ($[111] !== ad.category.id || $[112] !== ad.urn || $[113] !== hasSafetyTips) {
    t40 = hasSafetyTips && <SafetySection classes={[gridStyles["detail-component"]]} category={ad.category.id} urn={ad.urn} />;
    $[111] = ad.category.id;
    $[112] = ad.urn;
    $[113] = hasSafetyTips;
    $[114] = t40;
  } else {
    t40 = $[114];
  }
  let t41;
  let t42;
  if ($[115] !== ad) {
    t41 = <RecommendedAds item={ad} className={gridStyles["detail-component"]} onActualRender={increaseRowSpan} />;
    t42 = <RelatedAds item={ad} className={gridStyles["detail-component"]} onActualRender={increaseRowSpan} />;
    $[115] = ad;
    $[116] = t41;
    $[117] = t42;
  } else {
    t41 = $[116];
    t42 = $[117];
  }
  let t43;
  if ($[118] !== t13 || $[119] !== t15 || $[120] !== t17 || $[121] !== t18 || $[122] !== t23 || $[123] !== t24 || $[124] !== t25 || $[125] !== t27 || $[126] !== t29 || $[127] !== t30 || $[128] !== t31 || $[129] !== t32 || $[130] !== t35 || $[131] !== t37 || $[132] !== t39 || $[133] !== t40 || $[134] !== t41 || $[135] !== t42) {
    t43 = <div className={t12} style={t13}>{t15}{t17}{t18}{t23}{t24}{t25}{t27}{t28}{t29}{t30}{t31}{t32}{t35}{t36}{t37}{t39}{t40}{t41}{t42}</div>;
    $[118] = t13;
    $[119] = t15;
    $[120] = t17;
    $[121] = t18;
    $[122] = t23;
    $[123] = t24;
    $[124] = t25;
    $[125] = t27;
    $[126] = t29;
    $[127] = t30;
    $[128] = t31;
    $[129] = t32;
    $[130] = t35;
    $[131] = t37;
    $[132] = t39;
    $[133] = t40;
    $[134] = t41;
    $[135] = t42;
    $[136] = t43;
  } else {
    t43 = $[136];
  }
  let t44;
  if ($[137] !== isMobile) {
    t44 = !isMobile && <AdsAdDetailsBlock className={gridStyles["detail-component"]} />;
    $[137] = isMobile;
    $[138] = t44;
  } else {
    t44 = $[138];
  }
  let t45;
  if ($[139] !== ad || $[140] !== isMobile || $[141] !== isSoldItem || $[142] !== userIsSeller) {
    t45 = isMobile || isSoldItem && userIsSeller ? null : <StickyBar item={ad} />;
    $[139] = ad;
    $[140] = isMobile;
    $[141] = isSoldItem;
    $[142] = userIsSeller;
    $[143] = t45;
  } else {
    t45 = $[143];
  }
  let t46;
  if ($[144] !== isDesktop) {
    t46 = !isDesktop && <AdsGAMPlacement id={LiraContainerIds.adView.boxBelow2} />;
    $[144] = isDesktop;
    $[145] = t46;
  } else {
    t46 = $[145];
  }
  let t47;
  if ($[146] !== t43 || $[147] !== t44 || $[148] !== t45 || $[149] !== t46) {
    t47 = <div className={css["outer-ad-container"]}>{t43}{t44}{t45}{t46}</div>;
    $[146] = t43;
    $[147] = t44;
    $[148] = t45;
    $[149] = t46;
    $[150] = t47;
  } else {
    t47 = $[150];
  }
  let t48;
  if ($[151] !== ad) {
    t48 = <BottomSection item={ad} />;
    $[151] = ad;
    $[152] = t48;
  } else {
    t48 = $[152];
  }
  let t49;
  if ($[153] !== internalLinks) {
    t49 = internalLinks !== null ? <InternalLinksFooter links={internalLinks.footer} /> : null;
    $[153] = internalLinks;
    $[154] = t49;
  } else {
    t49 = $[154];
  }
  let t50;
  if ($[155] !== isDesktop) {
    t50 = isDesktop && <div id="apn_body" />;
    $[155] = isDesktop;
    $[156] = t50;
  } else {
    t50 = $[156];
  }
  let t51;
  if ($[157] !== t11 || $[158] !== t47 || $[159] !== t48 || $[160] !== t49 || $[161] !== t50) {
    t51 = <>{t11}{t47}{t48}{t49}{t50}</>;
    $[157] = t11;
    $[158] = t47;
    $[159] = t48;
    $[160] = t49;
    $[161] = t50;
    $[162] = t51;
  } else {
    t51 = $[162];
  }
  return t51;
}
function _temp(span) {
  return span + 1;
}
export default DefaultContainer;